<template>
	<v-card
		class="mx-auto"
	>
		<v-img
			lazy
			class="white--text align-end"
			max-height="256px"
			max-width="450px"
			:src="news.img"
		>
		</v-img>

		<v-card-subtitle class="pb-0">
			<span>{{news.heb_date}}</span>
			<v-divider vertical/>
			<span>{{time}}</span>
		</v-card-subtitle>

		<v-card-text class="text--primary">
			<div>
				{{news.content}}
			</div>
		</v-card-text>


	</v-card>
</template>

<script>
	export default {
		name: "news-card",
		props: {news: {required: true}},
		components: {},
		data() {
			return {};
		},
		computed: {
			time() {
				return moment(this.news.created_at).format("H:m");
			}
		},
		methods: {},
		watch: {},
		created() {
		},
		mounted() {
		},
		updated() {
		},
		destroyed() {
		}
	};
</script>

<style scoped>

</style>
